import {
  UserIcon,
  PowerIcon,
  HomeIcon,
  BuildingOfficeIcon,
  ClipboardDocumentListIcon,
  Cog6ToothIcon,
} from '@heroicons/react/24/outline'

export const menuItems: {path: string, svg: any, name: string, subpath: string[], submenu: {name: string, path: string, svg: any}[]}[] = [
  {
    path: '/',
    svg: HomeIcon,
    name: 'HOME',
    subpath: [],
    submenu: []
  },
  {
    path: '#',
    svg: BuildingOfficeIcon,
    name: 'TENANT_SERVICES',
    subpath: ['/contracts/add-contract', '/repairs-and-inquiries/new-request'],
    submenu: [
      { name: 'CONTRACTS', path: '/contracts', svg: ClipboardDocumentListIcon },
      { name: 'REPAIRS_AND_INQUIRIES', path: '/repairs-and-inquiries', svg: Cog6ToothIcon }
    ]
  },
  {
    path: '/account',
    name: 'ACCOUNT',
    svg: UserIcon,
    subpath: [
      '/account/edit-email',
      '/account/edit-password',
      '/account/delete-account'
    ],
    submenu: []
  },
  {
    path: '#',
    name: 'LOG_OUT',
    svg: PowerIcon,
    subpath: [],
    submenu: []
  }
]
